<template>
    <mdb-modal removeBackdrop size="lg" :show="modalShow" @close="handleClose">
        <mdb-modal-header class="text-center" color="indigo">
            <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
                $t("choose_subcategories")
                }}</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body class="mx-3" color="white">
            <div class="category-selector">
                <h3>{{ $t("selectable_subcategories") }}</h3>
                <div class="badges">
                    <span v-for="category in filteredSubCategories" :key="category"
                        :class="['badge', { selected: selectedSubCategories.find(selected => selected.id === category.id) }]" :style="getBadgeStyle(category)"
                        @click="toggleCategory(category)">
                        {{ category.name }}
                    </span>
                </div>
                <div class="selected-info">
                    <h3>{{ $t("selected_subcategories") }}</h3>
                    <span v-for="selectedCategory in selectedSubCategories" :key="selectedCategory"
                        class="badge selected" :style="getCategoryStyle(selectedCategory)">
                        {{ selectedCategory.name }}
                    </span>
                </div>
            </div>
        </mdb-modal-body>
        <mdb-modal-footer center>
            <mdb-btn @click="saveSelectedSubCategories" color="indigo">{{ $t("save") }}<mdb-icon icon="paper-plane"
                    class="ml-1" /></mdb-btn>
        </mdb-modal-footer>
    </mdb-modal>
</template>

<script>
import {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon,
} from "mdbvue";
export default {
    name: "PickSubCategories",
    props: {
        modalShow: {
            type: Boolean,
            default: false
        },
        selectedSubCats: {
            type: Array,
            default: () => []
        },
        selectedCats : {
            type: Array,
            default: () => []
        },
    },
    components: {
        mdbBtn,
        mdbModal,
        mdbModalHeader,
        mdbModalBody,
        mdbModalFooter,
        mdbModalTitle,
        mdbIcon,
    },
    computed: {
        filteredSubCategories() {
            if (!this.selectedCategories || this.selectedCategories.length === 0) {
                // Jos ei ole valittuja kategorioita, näytä kaikki
                return this.subCategories;
            }
            
            // Luo lista valittujen kategorioiden ID:istä
            const selectedCategoryIds = this.selectedCategories.map(cat => cat.id);
            
            // Filtteröi subcategoriat jotka kuuluvat valittuihin kategorioihin
            var subs = this.subCategories.filter(subCategory => 
                selectedCategoryIds.includes(subCategory.categoryid)
            );
            return subs;
        }
    },
    data() {
        return {
            subCategories: [],
            selectedSubCategories: this.selectedSubCats,
            selectedCategories: this.selectedCats,
            categoryColors: {},
            getsubcategoriespath: "/1.0/front/subcategories",
        };
    },
    methods: {
        getBadgeStyle(category) {
            return this.selectedSubCategories.find(selected => selected.id === category.id)
                ? this.getCategoryStyle(category)
                : {};
        },
        fetchSubCategories() {
            this.$http
                .get(this.getsubcategoriespath)
                .then((response) => {
                    this.subCategories = response.data.subcategories;
                })
                .catch((error) => {
                    console.error("Error fetching subcategories:", error);
                });
        },
        handleClose() {
            this.$emit("modal-cancelled");
        },
        saveSelectedSubCategories() {
            this.$emit("modal-ok", this.selectedSubCategories);
        },
        toggleCategory(category) {
            const index = this.selectedSubCategories.indexOf(category);
            if (index === -1) {
                this.selectedSubCategories.push(category);
                // Generoi satunnainen väri kun kategoria valitaan
                this.$set(this.categoryColors, category.name, this.generateRandomColor());
            } else {
                this.selectedSubCategories.splice(index, 1);
                // Poista väri kun kategoria poistetaan
                this.$delete(this.categoryColors, category.name);
            }
        },
        generateRandomColor() {
            const colors = [
                "#d5007e",
                /*"#4ECDC4",
                "#45B7D1",
                "#96CEB4",
                "#FFEAA7",
                "#DDA0DD",
                "#98D8C8",
                "#F7DC6F",
                "#BB8FCE",
                "#85C1E9",
                "#F8C471",
                "#82E0AA",
                "#F1948A",
                "#85C1E9",
                "#D7BDE2",
                "#A3E4D7",
                "#FAD7A0",
                "#D5A6BD",
                "#AED6F1",
                "#A9DFBF",*/
            ];
            return colors[Math.floor(Math.random() * colors.length)];
        },
        getCategoryStyle(category) {
            return {
                backgroundColor: this.categoryColors[category.name] || "#d5007e",
                color: "white",
            };
        },
        checkInitialSelectedCategories() {
            //var _self = this;
            //this.subcategories.forEach((category) => {
            //        console.log(category.name);
            //    _self.$set(_self.categoryColors, category.name, _self.generateRandomColor);
            //});
        },
    },
    mounted() {
        this.fetchSubCategories();
        this.checkInitialSelectedCategories();
    },
};
</script>

<style scoped>
.badges {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.badge {
    padding: 8px 12px;
    border-radius: 20px;
    background-color: #283c46;
    cursor: pointer;
    transition: 0.3s;
    border: 2px solid transparent;
}

.badge.selected:not([style*="background-color"]) {
    background-color: #007bff;
    color: white;
}

.badge:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.selected-info {
    margin-top: 20px;
}

.selected-info p {
    margin-bottom: 10px;
    font-weight: bold;
}

.selected-info .badge {
    margin-right: 5px;
    margin-bottom: 5px;
}
</style>
